import React from "react"
import { graphql } from "gatsby"

import LogoDark from '@/images/logos/logo-dark.inline.svg'

export default function Logo() {
  return <LogoDark />
}